import { remark } from "remark";
import remarkParse from "remark-parse";
import remarkReact from "remark-react";
import { createElement } from "react";
import { Headline, Body } from "@petsapp/chameleon";
import styled from "styled-components";

// TODO: use theme here
const StyledListItem = styled.li`
  text-align: justify;
  list-style-type: decimal;
  list-style-position: inside;
  text-align: justify;

  margin-bottom: 1.142857142rem;
  color: #6d7076;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4285714285714286rem;
`;

export function parseTerms(terms: string) {
  return remark()
    .use(remarkParse)
    .use(remarkReact, {
      createElement,
      remarkReactComponents: {
        p: Body,
        h1: Headline,
        h2: Headline,
        h3: Headline,
        h4: Headline,
        h5: Headline,
        li: StyledListItem,
      },
    })
    .processSync(terms).result;
}
